import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '../../store';

const offerPageSlice = createSlice({
  name: 'offerPage',
  initialState: {
    RFXLineItems: [],
    totalAcquisitionCost: null
  },
  reducers: {
    setRFXLineItems(state, action) {
      state.RFXLineItems = action.payload;
    },
    setTotalAcquisitionCost(state, action) {
      state.totalAcquisitionCost = action.payload;
    }
  }
});

export const { setRFXLineItems, setTotalAcquisitionCost } = offerPageSlice.actions;

export const selectRFXLineItems = (state: RootState) => state.offerPage.RFXLineItems;
export const selectTotalAcquisitionCost = (state: RootState) => state.offerPage.totalAcquisitionCost;

export default offerPageSlice.reducer;
